export default __webpack_public_path__ + "static/media/transporter.3be96034.svg";